import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import GameShowcase from './components/GameShowcase';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import SEOSchema from '@/components/feature/SEOSchema';
import SEOHead from '@/components/feature/SEOHead';
import { faqs } from '@/mocks/faq';

export default function Home() {
  return (
    <>
      <SEOHead
        title="麻将游戏在线玩 - 免费经典麻将，随时随地畅玩"
        description="想体验麻将游戏在线玩的乐趣？本页提供免费经典麻将、多种玩法模式，无需下载、即开即玩，支持手机与电脑，新手老手皆宜，随时随地享受正宗麻将对战乐趣。"
        keywords="麻将游戏在线玩,免费麻将游戏在线玩,麻将游戏在线玩不用下载,经典麻将在线玩,麻将单机游戏在线,四川麻将在线玩,麻将游戏免费玩"
        canonicalUrl="https://mahjong-online.com/"
        ogTitle="麻将游戏在线玩 - 免费经典麻将，随时随地畅玩"
        ogDescription="想体验麻将游戏在线玩的乐趣？本页提供免费经典麻将、多种玩法模式，无需下载、即开即玩，支持手机与电脑，新手老手皆宜。"
        ogUrl="https://mahjong-online.com/"
      />

      <SEOSchema
        type="WebPage"
        data={{
          name: '麻将游戏在线玩 - 首页',
          description: '免费经典麻将游戏在线玩平台首页，提供多种麻将玩法入口和游戏攻略',
          url: 'https://mahjong-online.com/',
        }}
      />
      <SEOSchema
        type="FAQPage"
        data={{
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <GameShowcase />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}